import { FC } from 'react';
import { Tooltip } from 'primereact/tooltip';

interface FieldDisplayProps {
  fieldValue: string | null | undefined;
  className?: string;
  style?: React.CSSProperties;
}

const stripFieldFormat = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .trim()
    .replace(/^\[/, '')
    .replace(/\]$/, '')
    .replace(/^["']/, '')
    .replace(/["']$/, '')
    .trim();
};

const getFieldDisplayName = (fieldPath: string): string => {
  if (!fieldPath) return '';
  const parts = fieldPath.split('.');
  return parts[parts.length - 1];
};

export const FieldDisplay: FC<FieldDisplayProps> = ({ 
  fieldValue, 
  className = '',
  style = {},
}) => {
  if (!fieldValue) {
    return <span className={className} style={style}>?</span>;
  }

  const strippedPath = stripFieldFormat(fieldValue);
  const displayName = getFieldDisplayName(strippedPath);
  const fullPath = fieldValue;
  const tooltipId = `field-${strippedPath.replace(/\./g, '-')}`;

  return (
    <>
      <Tooltip target={`.${tooltipId}`} />
      <span
        className={`${tooltipId} ${className}`}
        style={{
          cursor: 'default',
          ...style,
        }}
        data-pr-tooltip={fullPath}
        data-pr-position="top"
      >
        {displayName}
      </span>
    </>
  );
};
